module.exports = __webpack_public_path__ + "static/media/anc3ru.86a669e9.pdf";